import React, { useCallback, useContext } from 'react';
import { useMutation } from '@apollo/client';

import { MUTATION_CREATE_MEMBERSHIP } from './queries';
import MembershipForm from './components/MembershipForm';
import routes from 'constants/routes';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../contexts/UserContext';
import PermissionsAlert from '../../../components/PermissionsAlert/PermissionsAlert';

const MembershipCreate = () => {
  const navigate = useNavigate();
  const { dbUser } = useContext(UserContext);
  const [createMembership] = useMutation(MUTATION_CREATE_MEMBERSHIP);

  const submit = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async ({ capabilities, ...input }: any) => {
      await createMembership({
        variables: {
          input,
        },
      });

      navigate(routes.MEMBERSHIPS);
    },
    [navigate, createMembership],
  );

  if (dbUser && !dbUser.userPermissions.ManageSettings) {
    return <PermissionsAlert />;
  }

  return <MembershipForm handleSubmit={submit} />;
};

export default MembershipCreate;
